import z from 'zod';
import { AllCharLabelSchema, SubjectSchema, UnixTimestampSchema } from '../common/schemas';
import { LegacyExamTypeKey } from './enums';

/**
 * Shared & Helper Schemas
 */

/**
 * DB Schemas
 */

export const DBLegacyExamTypeSubjectSchema = SubjectSchema;
export const DBLegacyExamTypeTypeSchema = z.enum(LegacyExamTypeKey);
export const DBLegacyExamTypeCreationDatetimeSchema = UnixTimestampSchema;
export const DBLegacyExamTypeEditDatetimeSchema = UnixTimestampSchema;
export const DBLegacyExamTypeLabelSchema = AllCharLabelSchema.min(1).max(256);
export const DBLegacyExamTypeUnitPayDurationSchema = z.number().int().min(0);
export const DBLegacyExamTypeUnitPayRateSchema = z.number().int().min(0);

export const DBLegacyExamTypeSchema = z.object({
  subject: DBLegacyExamTypeSubjectSchema,
  type: DBLegacyExamTypeTypeSchema,
  creationDatetime: DBLegacyExamTypeCreationDatetimeSchema,
  editDatetime: DBLegacyExamTypeEditDatetimeSchema,
  label: DBLegacyExamTypeLabelSchema,
  unitPayDuration: DBLegacyExamTypeUnitPayDurationSchema,
  unitPayRate: DBLegacyExamTypeUnitPayRateSchema,
});

/**
 * Client Schemas
 */
export const LegacyExamTypeSubjectSchema = DBLegacyExamTypeSubjectSchema;
export const LegacyExamTypeTypeSchema = DBLegacyExamTypeTypeSchema;
export const LegacyExamTypeCreationDatetimeSchema = DBLegacyExamTypeCreationDatetimeSchema;
export const LegacyExamTypeEditDatetimeSchema = DBLegacyExamTypeEditDatetimeSchema;
export const LegacyExamTypeLabelSchema = DBLegacyExamTypeLabelSchema;
export const LegacyExamTypeUnitPayDurationSchema = DBLegacyExamTypeUnitPayDurationSchema;
export const LegacyExamTypeUnitPayRateSchema = DBLegacyExamTypeUnitPayRateSchema;

export const LegacyExamTypeSchema = z.object({
  subject: LegacyExamTypeSubjectSchema.meta({ title: 'Subject' }),
  type: LegacyExamTypeTypeSchema.meta({ title: 'Type ID' }),
  creationDatetime: LegacyExamTypeCreationDatetimeSchema.meta({ title: 'Created at' }),
  editDatetime: LegacyExamTypeEditDatetimeSchema.meta({ title: 'Last edited at' }),
  label: LegacyExamTypeLabelSchema.meta({ title: 'Type' }),
  unitPayDuration: LegacyExamTypeUnitPayDurationSchema.meta({
    title: 'Expected marking duration (mins)',
  }),
  unitPayRate: LegacyExamTypeUnitPayRateSchema.meta({ title: 'Pay rate (/paper)' }),
});
